import { CLEAR_AUTH_STATE, LOGIN_FAIL, LOGIN_LOADING, LOGIN_SUCCESS, LOGOUT_USER, TRAVERSING_FAIL, TRAVERSING_IN_FAIL, TRAVERSING_IN_LOADING, TRAVERSING_IN_SUCCESS, TRAVERSING_LOADING, TRAVERSING_SUCCESS } from "../Components/Constants/ActionTypes";


const Auth = (state,{type,payload}) => {

    switch (type) {
        case LOGIN_LOADING:
          return{
              ...state,
              AuthState:{
                ...state.AuthState,
                loading:true,
              }
          };

        case LOGIN_SUCCESS:
            return{
                ...state,
                AuthState:{
                    ...state.AuthState,
                    loading:false,
                    data:payload,
                    isLoggedIn:true,
                }
            };
        case LOGIN_FAIL:
            return{
                ...state,
                AuthState:{
                    ...state.AuthState,
                    loading:false,
                    error:payload,
                }
            };
        case LOGOUT_USER:
            return{
                ...state,
                AuthState:{
                    ...state.AuthState,
                    loading:false,
                    data:null,
                    isLoggedIn:false,
                }
            };

        case CLEAR_AUTH_STATE:
            return {
                ...state,
                AuthState:{
                    ...state.AuthState,
                    loading: false,
                    data: null,
                    error: null,
                }
                
            };

        case TRAVERSING_LOADING:
            return{
                ...state,
                traversingOutState:{
                    ...state.traversingOutState,
                    loading:true,
                }
            };
    
        case TRAVERSING_SUCCESS:
            return{
                ...state,
                traversingOutState:{
                    ...state.traversingOutState,
                    loading:false,
                    data:payload,
                    isLoggedIn:true,
                }
            };
        case TRAVERSING_FAIL:
            return{
                ...state,
                traversingOutState:{
                    ...state.traversingOutState,
                    loading:false,
                    error:payload,
                }
            };

        case TRAVERSING_IN_LOADING:
            return{
                ...state,
                traversingInState:{
                    ...state.traversingInState,
                    loading:true,
                }
            };
    
        case TRAVERSING_IN_SUCCESS:
            return{
                ...state,
                traversingInState:{
                    ...state.traversingInState,
                    loading:false,
                    data:payload,
                    isLoggedIn:true,
                }
            };
        case TRAVERSING_IN_FAIL:
            return{
                ...state,
                traversingInState:{
                    ...state.traversingInState,
                    loading:false,
                    error:payload,
                }
            };

        default:
           return false;
    }

}

export default Auth;